// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QChSD","content":"styles_content__1CuWV","tableWrap":"styles_tableWrap__2mlZD"};